import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/sobre' },
    { name: 'Services', path: '/servicos' },
    { name: 'Gallery', path: '/instagram' },
    { name: 'Contact', path: '/contato' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#484237]/95 backdrop-blur-md shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_home-improvement-pro/artifacts/tjia1iyl_Massimo_logo%202.png" 
              alt="Massimo Home Improvement" 
              className="h-14 w-auto transform group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative text-sm font-medium transition-colors duration-300 ${
                  isActive(item.path)
                    ? 'text-[#D7AC78]'
                    : 'text-white hover:text-[#D7AC78]'
                }`}
              >
                {item.name}
                {isActive(item.path) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#D7AC78]" />
                )}
              </Link>
            ))}
            <Link
              to="/contato"
              className="ml-4 px-6 py-2.5 bg-[#D7AC78] text-white text-sm font-medium rounded-lg hover:bg-[#c49a68] transform hover:scale-105 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Schedule Consultation
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-white hover:text-[#D7AC78] transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-600 animate-in slide-in-from-top duration-300">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? 'text-[#D7AC78] bg-white/10'
                      : 'text-white hover:text-[#D7AC78] hover:bg-white/5'
                  } rounded-lg`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contato"
                onClick={() => setIsMenuOpen(false)}
                className="mx-4 px-6 py-3 bg-[#D7AC78] text-white text-sm font-medium text-center rounded-lg hover:bg-[#c49a68] transition-colors"
              >
                Schedule Consultation
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
